import { FSModal } from '@/ui/components/modal/FSModal';

import { AssignExternalPublicView } from './assign-external-public/AssignExternalPublicView';

export function ModalAssignExternalPublic({
  projectId,
  open,
  onClose,
}: {
  projectId: number;
  open: boolean;
  onClose: () => void;
}) {
  return (
    <FSModal
      open={open}
      onClose={onClose}
      maxWidth={1200}
      showCloseButton={true}
    >
      <AssignExternalPublicView projectId={projectId} />
    </FSModal>
  );
}
